package songwritersnotebook.app.screens.components

import songwritersnotebook.app.screens.*

import androidx.compose.animation.AnimatedContent
import androidx.compose.animation.AnimatedVisibility
import androidx.compose.animation.fadeIn
import androidx.compose.animation.fadeOut
import androidx.compose.animation.slideInVertically
import androidx.compose.animation.slideOutVertically
import androidx.compose.animation.togetherWith
import androidx.compose.animation.core.animateFloat
import androidx.compose.animation.core.animateFloatAsState
import androidx.compose.animation.core.rememberInfiniteTransition
import androidx.compose.animation.core.infiniteRepeatable
import androidx.compose.animation.core.tween
import androidx.compose.animation.core.RepeatMode
import androidx.compose.animation.core.LinearEasing
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.font.FontStyle
import androidx.compose.ui.platform.LocalDensity
import androidx.compose.ui.text.TextStyle
import kotlin.math.absoluteValue
import androidx.compose.ui.text.TextRange
import androidx.compose.ui.text.TextLayoutResult
import androidx.compose.ui.text.input.TextFieldValue
import androidx.compose.ui.text.input.KeyboardCapitalization
import androidx.compose.ui.text.drawText
import androidx.compose.ui.text.rememberTextMeasurer
import androidx.compose.ui.unit.em
import kotlinx.coroutines.delay
import kotlinx.coroutines.withTimeoutOrNull
import androidx.compose.foundation.gestures.awaitEachGesture
import androidx.compose.foundation.gestures.awaitFirstDown
import androidx.compose.foundation.gestures.waitForUpOrCancellation
import androidx.compose.ui.draw.drawWithContent
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.geometry.Size
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.gestures.detectTapGestures
import androidx.compose.foundation.gestures.detectHorizontalDragGestures
import androidx.compose.ui.focus.FocusRequester
import androidx.compose.ui.focus.focusRequester
import androidx.compose.ui.focus.onFocusChanged
import androidx.compose.ui.input.pointer.pointerInput
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.itemsIndexed
import androidx.compose.foundation.horizontalScroll
import androidx.compose.foundation.rememberScrollState
import songwritersnotebook.app.utils.NetworkUtils
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.BasicTextField
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.foundation.text.KeyboardActions
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.ArrowBack
import androidx.compose.material.icons.automirrored.filled.MenuBook
import androidx.compose.material.icons.automirrored.filled.Send
import androidx.compose.material.icons.automirrored.filled.Undo
import androidx.compose.material.icons.automirrored.filled.Redo
import androidx.compose.material.icons.filled.*
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.alpha
import androidx.compose.ui.draw.clip
import androidx.compose.ui.draw.scale
import androidx.compose.ui.zIndex
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.BlendMode
import androidx.compose.ui.graphics.graphicsLayer
import androidx.compose.ui.text.font.FontFamily
import androidx.compose.ui.unit.DpSize
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.material.icons.filled.CloudDone
import androidx.compose.material.icons.filled.Save
import androidx.compose.material.icons.filled.Piano
import androidx.compose.material.icons.filled.Check
import songwritersnotebook.app.utils.rememberMicPermissionLauncher
import androidx.compose.material.icons.filled.Edit
import androidx.compose.material.icons.filled.Delete
import androidx.compose.material.icons.filled.MusicNote
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.ExperimentalLayoutApi
import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.lazy.LazyRow
import androidx.compose.foundation.lazy.items
import androidx.compose.ui.platform.LocalSoftwareKeyboardController
import androidx.compose.ui.window.Dialog
import androidx.compose.ui.window.DialogProperties
import androidx.compose.ui.text.input.ImeAction
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.geometry.CornerRadius
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import songwritersnotebook.app.billing.SubscriptionTier
import songwritersnotebook.app.billing.ProductInfo
import songwritersnotebook.app.data.*
import songwritersnotebook.app.navigation.AppRoutes
import songwritersnotebook.app.ui.theme.BlueAccent
import songwritersnotebook.app.ui.theme.GoldAccent
import songwritersnotebook.app.ui.theme.SliderThumbGray
import songwritersnotebook.app.ui.theme.SliderTrackGray
import songwritersnotebook.app.ui.theme.ChordVisualTransformation
import songwritersnotebook.app.utils.countSyllables
import songwritersnotebook.app.viewmodels.*
import kotlinx.datetime.*
import org.jetbrains.compose.resources.painterResource
import songwritersnotebookapp.composeapp.generated.resources.Res
import songwritersnotebookapp.composeapp.generated.resources.ic_guitar
import songwritersnotebook.app.ui.theme.SuccessGreen
import songwritersnotebook.app.components.SaveStatusIndicator
import songwritersnotebook.app.adaptiveSheetWidth
import songwritersnotebook.app.components.ChordPanel
import songwritersnotebook.app.components.ChordCreatorSheet
import songwritersnotebook.app.components.HarmonyAiTabContent
import songwritersnotebook.app.components.TabEditorSheet
import songwritersnotebook.app.components.RecordingSheet
import songwritersnotebook.app.components.LineMediaSheet
import songwritersnotebook.app.components.TabDisplay
import songwritersnotebook.app.components.LoadingOverlay
import songwritersnotebook.app.tutorial.TutorialManager
import songwritersnotebook.app.tutorial.TutorialStep
import songwritersnotebook.app.tutorial.tutorialTarget
import androidx.compose.material3.SegmentedButton
import androidx.compose.material3.SegmentedButtonDefaults
import androidx.compose.material3.SingleChoiceSegmentedButtonRow
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.verticalScroll
import androidx.compose.foundation.rememberScrollState
import songwritersnotebook.app.tutorial.TutorialOverlay
import songwritersnotebook.app.LocalPlatformContext
import androidx.compose.ui.input.key.onPreviewKeyEvent
import androidx.compose.ui.input.key.Key
import androidx.compose.ui.input.key.key
import androidx.compose.ui.input.key.type
import androidx.compose.ui.input.key.KeyEventType
import androidx.compose.ui.unit.IntOffset
import songwritersnotebook.app.components.VersionHistorySheet


@Composable
fun SongSectionItem(
    section: Section,
    sectionIndex: Int,
    viewModel: EditorViewModel,
    uiState: EditorUiState,
    onSelectItem: (Int?) -> Unit,
    fontSize: androidx.compose.ui.unit.TextUnit,
    canUseTabs: Boolean,
    isPreview: Boolean = false
) {
    val focusRequest = uiState.nextFocusRequest
    val songRecordings = if (isPreview) uiState.versionPreview?.recordings ?: emptyMap() else uiState.song?.recordings ?: emptyMap()
    val allRecordings = songRecordings.values.flatten()
    val currentStep by TutorialManager.currentStep.collectAsState()
    val effectiveReadOnly = isPreview || uiState.isViewer

    Column(
        modifier = Modifier.fillMaxWidth()
    ) {
        if (uiState.editorSettings.showSectionHeaders) {
            key(section.id) {
                EditableSectionTitle(
                    section = section,
                    onTitleChange = { newTitle ->
                        viewModel.updateSectionTitle(sectionIndex, newTitle)
                    },
                    onSelect = { if (!isPreview) onSelectItem(null) },
                    focusRequest = if (focusRequest?.targetId == section.id && focusRequest.isSectionTitle) focusRequest else null,
                    onFocusHandled = { viewModel.onFocusHandled() },
                    onFocus = { isFocused -> if (!isPreview) viewModel.onSectionTitleFocusChanged(sectionIndex, isFocused) },
                    hasMedia = !songRecordings[section.id].isNullOrEmpty() || section.tabs.isNotEmpty(),
                    onManageRecordings = { viewModel.openLineMediaSheet(section.id) },
                    onDeleteHeaderRequest = { viewModel.deleteSectionHeaderOrMerge(sectionIndex) },
                    readOnly = effectiveReadOnly,
                    remotePresences = uiState.presence.values.filter { it.activeSectionId == section.id && it.activeLineId == null },
                    fontSize = fontSize
                )
            }
            
            if (uiState.editorSettings.showTabs && section.tabs.isNotEmpty()) {
                LazyRow(
                    contentPadding = PaddingValues(horizontal = 16.dp, vertical = 4.dp),
                    horizontalArrangement = Arrangement.spacedBy(16.dp)
                ) {
                    items(section.tabs) { tab ->
                        val tabRecordings = allRecordings.filter { it.id in tab.recordingIds }
                        Box(modifier = Modifier.clickable {
                            if (isPreview) {
                                if (tabRecordings.isNotEmpty()) viewModel.playRecording(tabRecordings.last())
                            } else if (canUseTabs) {
                                viewModel.openTabEditor(section.id, tab)
                            }
                        }) {

                            TabDisplay(
                                tab = tab,
                                isPlaying = tabRecordings.any { it.id == uiState.playingRecordingId },
                                onPlay = if (tabRecordings.isNotEmpty()) {
                                    { viewModel.playRecording(tabRecordings.last()) }
                                } else null,
                                remotePresences = uiState.presence.values.filter { it.activeTabId == tab.id }
                            )
                        }
                    }
                }
            }
        }

        Column {
            section.lines.forEachIndexed { lineIndex, line ->
                key(line.id) {
                    val contextMenuModifier = if (!isPreview && sectionIndex == 0 && lineIndex == 0) {
                        Modifier.tutorialTarget(TutorialStep.EDITOR_CONTEXT_MENU_OPEN)
                    } else {
                        Modifier
                    }
                    
                    EditableLyricLine(
                        line = line,
                        onTextChange = { newTextFieldValue ->
                            viewModel.updateLineText(sectionIndex, lineIndex, newTextFieldValue)
                        },
                        editorSettings = uiState.editorSettings,
                        onSelect = { 
                            if (!isPreview) {
                                if (sectionIndex == 0 && lineIndex == 0 && currentStep == TutorialStep.EDITOR_CONTEXT_MENU_OPEN) {
                                    TutorialManager.nextStep()
                                }
                                onSelectItem(lineIndex) 
                            }
                        },
                        onChordInsert = { cursorPosition ->
                            uiState.selectedChordToPlace?.let { chord ->
                                viewModel.insertChordAtCursor(sectionIndex, lineIndex, cursorPosition, chord)
                            }
                        },
                        isChordArmed = !isPreview && uiState.selectedChordToPlace != null,
                        rhymeData = uiState.rhymeData,
                        focusRequest = if (focusRequest?.targetId == line.id && !focusRequest.isSectionTitle) focusRequest else null,
                        onFocusHandled = { viewModel.onFocusHandled() },
                        onFocus = { isFocused -> if (!isPreview) viewModel.onLineFocusChanged(sectionIndex, lineIndex, isFocused) },
                        onMergeRequest = {
                            viewModel.mergeLineWithPrevious(sectionIndex, lineIndex, line.text)
                        },
                        contextMenuModifier = contextMenuModifier,
                        hasMedia = !songRecordings[line.id].isNullOrEmpty() || line.tabs.isNotEmpty(),
                        onManageRecordings = { viewModel.openLineMediaSheet(line.id) },
                        fontSize = fontSize,
                        canUseTabs = canUseTabs,
                        readOnly = effectiveReadOnly,
                        remotePresences = uiState.presence.values.filter { it.activeLineId == line.id }
                    )
                }
                
                if (uiState.editorSettings.showTabs && line.tabs.isNotEmpty()) {
                    LazyRow(
                        contentPadding = PaddingValues(start = 40.dp, end = 16.dp, top = 4.dp, bottom = 12.dp),
                        horizontalArrangement = Arrangement.spacedBy(16.dp)
                    ) {
                        items(line.tabs) { tab ->
                            val tabRecordings = allRecordings.filter { it.id in tab.recordingIds }
                            Box(modifier = Modifier.clickable {
                                if (isPreview) {
                                    if (tabRecordings.isNotEmpty()) viewModel.playRecording(tabRecordings.last())
                                } else if (canUseTabs) {
                                    viewModel.openTabEditor(line.id, tab)
                                }
                            }) {
                                TabDisplay(
                                    tab = tab,
                                    isPlaying = tabRecordings.any { it.id == uiState.playingRecordingId },
                                    onPlay = if (tabRecordings.isNotEmpty()) {
                                        { viewModel.playRecording(tabRecordings.last()) }
                                    } else null,
                                    remotePresences = uiState.presence.values.filter { it.activeTabId == tab.id }
                                )
                            }
                        }
                    }
                }
            }
        }
    }
}


@Composable
fun EditableSectionTitle(
    section: Section,
    onTitleChange: (String) -> Unit,
    onSelect: () -> Unit,
    focusRequest: songwritersnotebook.app.viewmodels.FocusRequest? = null,
    onFocusHandled: () -> Unit = {},
    onFocus: (Boolean) -> Unit = {},
    hasMedia: Boolean = false,
    onManageRecordings: () -> Unit = {},
    onDeleteHeaderRequest: () -> Unit = {},
    readOnly: Boolean = false,
    remotePresences: List<songwritersnotebook.app.data.UserPresence> = emptyList(),
    onNavigateUp: (Float?) -> Unit = {},
    onNavigateDown: (Float?) -> Unit = {},
    fontSize: androidx.compose.ui.unit.TextUnit = MaterialTheme.typography.titleMedium.fontSize
) {
    val focusRequester = remember { FocusRequester() }
    var textFieldValue by remember { 
        mutableStateOf(TextFieldValue(text = section.title, selection = TextRange(section.title.length))) 
    }
    var lastLocalEdit by remember { mutableStateOf(0L) }
    var textLayoutResult by remember { mutableStateOf<TextLayoutResult?>(null) }
    var localIsFocused by remember { mutableStateOf(false) }
    var pendingOffsetRequest by remember { mutableStateOf<Pair<Float, FocusPivot?>?>(null) }

    LaunchedEffect(section.title) {
        val now = Clock.System.now().toEpochMilliseconds()
        val isTyping = (now - lastLocalEdit) < 2000L // 2-second guard
        
        if (!isTyping && textFieldValue.text != section.title) {
            val oldText = textFieldValue.text
            val newText = section.title
            val oldSelection = textFieldValue.selection

            val newSelection = if (newText.length > oldText.length) {
                val diffLen = newText.length - oldText.length
                val isPrefixMatch = oldText.take(oldSelection.start.coerceAtMost(oldText.length)) == 
                                   newText.take(oldSelection.start.coerceAtMost(oldText.length))
                if (isPrefixMatch) oldSelection else TextRange(oldSelection.start + diffLen, oldSelection.end + diffLen)
            } else if (newText.length < oldText.length) {
                val diffLen = oldText.length - newText.length
                val isPrefixMatch = oldText.take(oldSelection.start.coerceAtMost(oldText.length)) == 
                                   newText.take(oldSelection.start.coerceAtMost(oldText.length))
                if (isPrefixMatch) oldSelection else TextRange((oldSelection.start - diffLen).coerceAtLeast(0), (oldSelection.end - diffLen).coerceAtLeast(0))
            } else {
                oldSelection
            }

            textFieldValue = textFieldValue.copy(text = newText, selection = newSelection)
        }
    }

    LaunchedEffect(focusRequest) {
        if (focusRequest != null && !readOnly) {
            focusRequester.requestFocus()
            if (focusRequest.horizontalOffset != null) {
                val layoutRes = textLayoutResult
                if (layoutRes != null) {
                    val y = (layoutRes.getLineTop(0) + layoutRes.getLineBottom(0)) / 2f
                    val targetOffset = layoutRes.getOffsetForPosition(Offset(focusRequest.horizontalOffset, y))
                    textFieldValue = textFieldValue.copy(selection = TextRange(targetOffset))
                    pendingOffsetRequest = null
                } else {
                    pendingOffsetRequest = Pair(focusRequest.horizontalOffset, focusRequest.focusPivot)
                }
            } else {
                textFieldValue = textFieldValue.copy(selection = focusRequest.cursorPosition)
            }
            onFocusHandled()
        }
    }

    Row(
        verticalAlignment = Alignment.CenterVertically,
        modifier = Modifier
            .fillMaxWidth()
            .drawWithContent {
                if (remotePresences.isNotEmpty()) {
                    val strokeWidth = 1.dp.toPx()
                    val totalLength = (size.width + size.height) * 2
                    val segmentLength = totalLength / remotePresences.size
                    
                    var currentPos = 0f
                    remotePresences.forEach { presence ->
                        val color = Color(if (presence.color != 0) presence.color else songwritersnotebook.app.data.UserPresence.generateUserColor(presence.userId))
                        val start = currentPos
                        val end = currentPos + segmentLength
                        
                        fun drawBorderSegment(from: Float, to: Float) {
                            fun getPoint(pos: Float): Offset {
                                var p = pos % totalLength
                                if (p < 0) p += totalLength
                                return when {
                                    p < size.width -> Offset(p, 0f)
                                    p < size.width + size.height -> Offset(size.width, p - size.width)
                                    p < size.width * 2 + size.height -> Offset(size.width - (p - (size.width + size.height)), size.height)
                                    else -> Offset(0f, size.height - (p - (size.width * 2 + size.height)))
                                }
                            }
                            
                            val step = 2.dp.toPx()
                            var s = from
                            while (s < to) {
                                val next = (s + step).coerceAtMost(to)
                                drawLine(
                                    color = color,
                                    start = getPoint(s),
                                    end = getPoint(next),
                                    strokeWidth = strokeWidth
                                )
                                s = next
                            }
                        }
                        
                        drawBorderSegment(start, end)
                        currentPos += segmentLength
                    }
                }
                drawContent()
            }
            .padding(vertical = 4.dp)
    ) {
        if (readOnly) {
             Row(verticalAlignment = Alignment.CenterVertically) {
                 Icon(
                     Icons.Default.Visibility, 
                     contentDescription = "Read only", 
                     modifier = Modifier.size(24.dp).padding(4.dp),
                     tint = MaterialTheme.colorScheme.onSurface.copy(alpha = 0.5f)
                 )
             }
        } else {
            IconButton(onClick = onSelect, modifier = Modifier.size(24.dp)) {
                Icon(Icons.Default.MoreVert, contentDescription = "Section options", modifier = Modifier.alpha(0.3f))
            }
        }
        
        Box(modifier = Modifier.weight(1f)) {
            BasicTextField(
                value = textFieldValue,
                onValueChange = {
                    if (!readOnly) {
                        textFieldValue = it
                        lastLocalEdit = Clock.System.now().toEpochMilliseconds()
                        onTitleChange(it.text)
                    }
                },
                textStyle = TextStyle(
                    color = if (readOnly) MaterialTheme.colorScheme.onSurface.copy(alpha = 0.5f) else MaterialTheme.colorScheme.onBackground,
                    fontSize = fontSize,
                    fontWeight = FontWeight.Bold
                ),
                modifier = Modifier.fillMaxWidth().padding(horizontal = 8.dp)
                    .focusRequester(focusRequester)
                    .onFocusChanged { state -> 
                        localIsFocused = state.isFocused
                        if (!readOnly) onFocus(state.isFocused) 
                    }
                    .onPreviewKeyEvent { event ->
                        if (!readOnly && event.type == KeyEventType.KeyDown) {
                            when (event.key) {
                                Key.Backspace -> {
                                    if (textFieldValue.text.isEmpty()) {
                                        onDeleteHeaderRequest()
                                        true
                                    } else {
                                        false
                                    }
                                }
                                Key.DirectionUp -> {
                                    if (textFieldValue.selection.collapsed) {
                                        val cursorOffset = textFieldValue.selection.start
                                        val cursorRect = textLayoutResult?.getCursorRect(cursorOffset)
                                        onNavigateUp(cursorRect?.left)
                                        true
                                    } else {
                                        false
                                    }
                                }
                                Key.DirectionDown -> {
                                    if (textFieldValue.selection.collapsed) {
                                        val cursorOffset = textFieldValue.selection.start
                                        val cursorRect = textLayoutResult?.getCursorRect(cursorOffset)
                                        onNavigateDown(cursorRect?.left)
                                        true
                                    } else {
                                        false
                                    }
                                }
                                else -> false
                            }
                        } else {
                            false
                        }
                    },
                singleLine = true,
                cursorBrush = SolidColor(MaterialTheme.colorScheme.onSurface),
                enabled = !readOnly,
                readOnly = readOnly,
                onTextLayout = { res ->
                    textLayoutResult = res
                    pendingOffsetRequest?.let { (hOffset, pivot) ->
                        val y = (res.getLineTop(0) + res.getLineBottom(0)) / 2f
                        val targetOffset = res.getOffsetForPosition(Offset(hOffset, y))
                        textFieldValue = textFieldValue.copy(selection = TextRange(targetOffset))
                        pendingOffsetRequest = null
                    }
                }
            )
            
            songwritersnotebook.app.screens.components.RemoteCursorsOverlay(
                remotePresences = remotePresences,
                textLayoutResult = textLayoutResult,
                modifier = Modifier.padding(horizontal = 8.dp)
            )
        }
        
        // --- IMPROVED DISCOVERABILITY ---
        // If it has media, show the QueueMusic icon.
        // If it's focused but has NO media, show a subtle Plus icon.
        val showPlusHint = localIsFocused && !hasMedia && !readOnly
        
        if (hasMedia || showPlusHint) {
            IconButton(
                onClick = onManageRecordings, 
                modifier = Modifier.size(24.dp)
            ) {
                Icon(
                    imageVector = if (hasMedia) Icons.Filled.QueueMusic else Icons.Default.Add,
                    contentDescription = if (hasMedia) "Manage Media" else "Add Media",
                    tint = if (hasMedia) {
                        MaterialTheme.colorScheme.primary 
                    } else {
                        MaterialTheme.colorScheme.onSurface.copy(alpha = 0.3f)
                    }
                )
            }
        }
    }
}


@Composable
fun EditableLyricLine(
    line: Line,
    onTextChange: (TextFieldValue) -> Unit,
    editorSettings: EditorSettings,
    onSelect: () -> Unit,
    onChordInsert: (Int) -> Unit,
    isChordArmed: Boolean,
    rhymeData: Map<String, RhymeInfo>,
    focusRequest: songwritersnotebook.app.viewmodels.FocusRequest? = null,
    onFocusHandled: () -> Unit = {},
    onFocus: (Boolean) -> Unit = {},
    onMergeRequest: () -> Unit = {},
    contextMenuModifier: Modifier = Modifier,
    hasMedia: Boolean = false,
    onManageRecordings: () -> Unit = {},
    fontSize: androidx.compose.ui.unit.TextUnit,
    canUseTabs: Boolean,
    readOnly: Boolean = false,
    remotePresences: List<songwritersnotebook.app.data.UserPresence> = emptyList(),
    onNavigateUp: (Float?) -> Unit = {},
    onNavigateDown: (Float?) -> Unit = {}
) {
    val focusRequester = remember { FocusRequester() }
    var textFieldValue by remember { mutableStateOf(TextFieldValue(text = line.text)) }
    var lastLocalEdit by remember { mutableStateOf(0L) }
    var lastExternalEdit by remember { mutableStateOf(0L) }
    var textLayoutResult by remember { mutableStateOf<TextLayoutResult?>(null) }
    val currentStep by TutorialManager.currentStep.collectAsState()
    var localIsFocused by remember { mutableStateOf(false) }
    var pendingOffsetRequest by remember { mutableStateOf<Pair<Float, FocusPivot?>?>(null) }

    var lastKnownLineText by remember { mutableStateOf(line.text) }
    if (lastKnownLineText != line.text) {
        if (textFieldValue.text != line.text) {
            val oldText = textFieldValue.text
            val newText = line.text
            val oldSelection = textFieldValue.selection
            
            val newSelection = if (newText.length > oldText.length) {
                val diffLen = newText.length - oldText.length
                val isPrefixMatch = oldText.take(oldSelection.start.coerceAtMost(oldText.length)) == 
                                   newText.take(oldSelection.start.coerceAtMost(newText.length))
                if (isPrefixMatch) {
                    oldSelection
                } else {
                    TextRange(oldSelection.start + diffLen)
                }
            } else if (newText.length < oldText.length) {
                val diffLen = oldText.length - newText.length
                val isPrefixMatch = oldText.take(oldSelection.start.coerceAtMost(oldText.length)) == 
                                   newText.take(oldSelection.start.coerceAtMost(newText.length))
                if (isPrefixMatch) {
                    oldSelection
                } else {
                    TextRange((oldSelection.start - diffLen).coerceAtLeast(0))
                }
            } else {
                oldSelection
            }

            lastExternalEdit = Clock.System.now().toEpochMilliseconds()
            textFieldValue = textFieldValue.copy(text = newText, selection = newSelection)
        }
        lastKnownLineText = line.text
    }

    LaunchedEffect(focusRequest) {
        if (focusRequest != null && !readOnly) {
            focusRequester.requestFocus()
            if (focusRequest.horizontalOffset != null) {
                val layoutRes = textLayoutResult
                if (layoutRes != null) {
                    val targetLineIndex = if (focusRequest.focusPivot == FocusPivot.BOTTOM) {
                        (layoutRes.lineCount - 1).coerceAtLeast(0)
                    } else {
                        0
                    }
                    val y = (layoutRes.getLineTop(targetLineIndex) + layoutRes.getLineBottom(targetLineIndex)) / 2f
                    val targetOffset = layoutRes.getOffsetForPosition(Offset(focusRequest.horizontalOffset, y))
                    textFieldValue = textFieldValue.copy(selection = TextRange(targetOffset))
                    pendingOffsetRequest = null
                } else {
                    pendingOffsetRequest = Pair(focusRequest.horizontalOffset, focusRequest.focusPivot)
                }
            } else {
                textFieldValue = textFieldValue.copy(selection = focusRequest.cursorPosition)
            }
            onFocusHandled()
        }
    }

    val remoteUserColor = remotePresences.firstOrNull()?.color?.let { Color(it) } ?: MaterialTheme.colorScheme.secondary
    val focusBarAlpha by animateFloatAsState(if (remotePresences.isNotEmpty()) 1f else 0f)

    Row(
        verticalAlignment = Alignment.CenterVertically,
        modifier = Modifier
            .fillMaxWidth()
            .drawWithContent {
                if (remotePresences.isNotEmpty()) {
                    val strokeWidth = 1.dp.toPx()
                    val totalLength = (size.width + size.height) * 2
                    val segmentLength = totalLength / remotePresences.size
                    
                    var currentPos = 0f
                    remotePresences.forEach { presence ->
                        val color = Color(if (presence.color != 0) presence.color else songwritersnotebook.app.data.UserPresence.generateUserColor(presence.userId))
                        val start = currentPos
                        val end = currentPos + segmentLength
                        
                        fun drawBorderSegment(from: Float, to: Float) {
                            fun getPoint(pos: Float): Offset {
                                var p = pos % totalLength
                                if (p < 0) p += totalLength
                                return when {
                                    p < size.width -> Offset(p, 0f)
                                    p < size.width + size.height -> Offset(size.width, p - size.width)
                                    p < size.width * 2 + size.height -> Offset(size.width - (p - (size.width + size.height)), size.height)
                                    else -> Offset(0f, size.height - (p - (size.width * 2 + size.height)))
                                }
                            }
                            
                            val step = 2.dp.toPx()
                            var s = from
                            while (s < to) {
                                val next = (s + step).coerceAtMost(to)
                                drawLine(
                                    color = color,
                                    start = getPoint(s),
                                    end = getPoint(next),
                                    strokeWidth = strokeWidth
                                )
                                s = next
                            }
                        }
                        
                        drawBorderSegment(start, end)
                        currentPos += segmentLength
                    }
                }
                drawContent()
            }
            .padding(horizontal = 4.dp, vertical = 2.dp)
    ) {
        if (readOnly) {
             Spacer(modifier = Modifier.size(24.dp)) // Placeholder for alignment
        } else {
            IconButton(onClick = onSelect, modifier = Modifier.size(24.dp).then(contextMenuModifier)) {
                Icon(Icons.Default.MoreVert, contentDescription = "Line options", modifier = Modifier.alpha(0.3f))
            }
        }
        
        Spacer(modifier = Modifier.width(4.dp))

        val visualTransformation = remember(editorSettings, rhymeData) {
             ChordVisualTransformation(
                 chordBackgroundColor = if (readOnly) Color.Gray else BlueAccent,
                 chordTextColor = Color.White,
                 activeChordHighlightColor = GoldAccent,
                 displayMode = editorSettings.chordDisplay,
                 chordPlacement = editorSettings.chordPlacement,
                 rhymeData = rhymeData,
                 textColor = if (readOnly) Color.Gray else Color.Unspecified,
                 endOfLineOnly = editorSettings.endOfLineOnly
             )
        }
        
        val textMeasurer = androidx.compose.ui.text.rememberTextMeasurer()
        val chordsToDraw = remember(line.text) {
            val chordRegex = Regex("\\[([^\\[\\]]+)\\]")
            val list = mutableListOf<Pair<String, Int>>()
            var visualOffset = 0
            var originalOffset = 0
            chordRegex.findAll(line.text).forEach { match ->
                visualOffset += match.range.first - originalOffset
                list.add(match.groupValues[1] to visualOffset)
                originalOffset = match.range.last + 1
            }
            list
        }

        Box(modifier = Modifier.weight(1f)) {
            BasicTextField(
                value = textFieldValue,
                onValueChange = { newValue ->
                    if (!readOnly) {
                        val now = Clock.System.now().toEpochMilliseconds()
                        if (now - lastExternalEdit < 500L) {
                            return@BasicTextField
                        }
                        
                        if (newValue.text.contains('\n')) {
                            // If they paste multi-line text, we only take the first line for this field
                            // and ideally we'd split and create new lines, but for now we just truncate
                            val parts = newValue.text.split('\n', limit = 2)
                            textFieldValue = newValue.copy(text = parts[0], selection = TextRange(parts[0].length))
                            onTextChange(newValue)
                        } else {
                            lastLocalEdit = Clock.System.now().toEpochMilliseconds()
                            textFieldValue = newValue
                            onTextChange(newValue)
                        }
                    }
                },
                readOnly = readOnly,
                textStyle = TextStyle(
                    color = if (readOnly) MaterialTheme.colorScheme.onSurface.copy(alpha = 0.5f) else MaterialTheme.colorScheme.onSurface,
                    fontFamily = FontFamily.Monospace,
                    fontSize = fontSize,
                    lineHeight = if (editorSettings.chordPlacement == songwritersnotebook.app.viewmodels.ChordPlacement.Above && editorSettings.chordDisplay != ChordDisplayMode.Off) 2.5.em else androidx.compose.ui.unit.TextUnit.Unspecified,
                    lineHeightStyle = androidx.compose.ui.text.style.LineHeightStyle(
                        alignment = androidx.compose.ui.text.style.LineHeightStyle.Alignment.Bottom,
                        trim = androidx.compose.ui.text.style.LineHeightStyle.Trim.None
                    )
                ),
                modifier = Modifier.fillMaxWidth()
                    .drawWithContent {
                        drawContent()
                        if (editorSettings.chordPlacement == songwritersnotebook.app.viewmodels.ChordPlacement.Above && editorSettings.chordDisplay != ChordDisplayMode.Off) {
                            textLayoutResult?.let { layout ->
                                val chordStyle = TextStyle(
                                    color = if (readOnly) Color.Gray else BlueAccent,
                                    fontSize = 12.sp,
                                    fontWeight = FontWeight.Bold
                                )
                                chordsToDraw.forEach { (chordName, visualOffset) ->
                                    val safeOffset = visualOffset.coerceIn(0, layout.layoutInput.text.length)
                                    val rect = layout.getBoundingBox(safeOffset)
                                    
                                    val chordText = if (editorSettings.chordDisplay == ChordDisplayMode.Large) " $chordName " else chordName
                                    
                                    val topLeft = Offset(x = rect.left, y = rect.top + 12.sp.toPx())
                                    drawText(
                                        textMeasurer = textMeasurer,
                                        text = chordText,
                                        topLeft = topLeft,
                                        style = chordStyle
                                    )
                                }
                            }
                        }
                    }
                    .focusRequester(focusRequester)
                    .onFocusChanged { state -> 
                        localIsFocused = state.isFocused
                        if (!readOnly) onFocus(state.isFocused) 
                    }
                    .onPreviewKeyEvent { event ->
                        if (!readOnly && event.type == KeyEventType.KeyDown) {
                            when (event.key) {
                                Key.Backspace -> {
                                    lastLocalEdit = Clock.System.now().toEpochMilliseconds()
                                    if (textFieldValue.selection.start == 0 && textFieldValue.selection.end == 0) {
                                        onMergeRequest()
                                        true
                                    } else {
                                        false
                                    }
                                }
                                Key.Enter -> {
                                    lastLocalEdit = Clock.System.now().toEpochMilliseconds()
                                    val text = textFieldValue.text
                                    val selection = textFieldValue.selection
                                    val start = selection.min
                                    val end = selection.max
                                    
                                    val firstPart = text.substring(0, start)
                                    val secondPart = text.substring(end)
                                    
                                    textFieldValue = textFieldValue.copy(text = firstPart, selection = TextRange(firstPart.length))
                                    
                                    val newText = firstPart + "\n" + secondPart
                                    onTextChange(textFieldValue.copy(text = newText))
                                    true
                                }
                                Key.DirectionUp -> {
                                    if (textFieldValue.selection.collapsed) {
                                        val cursorOffset = textFieldValue.selection.start
                                        val currentLine = textLayoutResult?.getLineForOffset(cursorOffset) ?: 0
                                        if (currentLine == 0) {
                                            val cursorRect = textLayoutResult?.getCursorRect(cursorOffset)
                                            onNavigateUp(cursorRect?.left)
                                            true
                                        } else {
                                            false
                                        }
                                    } else {
                                        false
                                    }
                                }
                                Key.DirectionDown -> {
                                    if (textFieldValue.selection.collapsed) {
                                        val cursorOffset = textFieldValue.selection.start
                                        val currentLine = textLayoutResult?.getLineForOffset(cursorOffset) ?: 0
                                        val lineCount = textLayoutResult?.lineCount ?: 1
                                        if (currentLine == lineCount - 1) {
                                            val cursorRect = textLayoutResult?.getCursorRect(cursorOffset)
                                            onNavigateDown(cursorRect?.left)
                                            true
                                        } else {
                                            false
                                        }
                                    } else {
                                        false
                                    }
                                }
                                else -> false
                            }
                        } else {
                            false
                        }
                    },
                visualTransformation = visualTransformation,
                keyboardOptions = KeyboardOptions(capitalization = KeyboardCapitalization.Sentences),
                onTextLayout = { res ->
                    textLayoutResult = res
                    pendingOffsetRequest?.let { (hOffset, pivot) ->
                        val targetLineIndex = if (pivot == FocusPivot.BOTTOM) {
                            (res.lineCount - 1).coerceAtLeast(0)
                        } else {
                            0
                        }
                        val y = (res.getLineTop(targetLineIndex) + res.getLineBottom(targetLineIndex)) / 2f
                        val targetOffset = res.getOffsetForPosition(Offset(hOffset, y))
                        textFieldValue = textFieldValue.copy(selection = TextRange(targetOffset))
                        pendingOffsetRequest = null
                    }
                },
                cursorBrush = SolidColor(MaterialTheme.colorScheme.onSurface),
                enabled = !readOnly
            )

            songwritersnotebook.app.screens.components.RemoteCursorsOverlay(
                remotePresences = remotePresences,
                textLayoutResult = textLayoutResult
            )

            if (isChordArmed && !readOnly) {
                Box(
                    modifier = Modifier
                        .matchParentSize()
                        .background(MaterialTheme.colorScheme.primary.copy(alpha = 0.1f))
                        .pointerInput(Unit) {
                            detectTapGestures { offset ->
                                textLayoutResult?.let { layoutResult ->
                                    val characterIndex = layoutResult.getOffsetForPosition(offset)
                                    onChordInsert(characterIndex)
                                }
                            }
                        }
                )
            }
        }
        
        // --- IMPROVED DISCOVERABILITY ---
        // If it has media, show the QueueMusic icon.
        // If it's focused but has NO media, show a subtle Plus icon.
        val showPlusHint = localIsFocused && !hasMedia && !readOnly
        
        if (hasMedia || showPlusHint) {
            IconButton(
                onClick = onManageRecordings, 
                modifier = Modifier.size(24.dp)
            ) {
                Icon(
                    imageVector = if (hasMedia) Icons.Filled.QueueMusic else Icons.Default.Add,
                    contentDescription = if (hasMedia) "Manage Media" else "Add Media",
                    tint = if (hasMedia) {
                        MaterialTheme.colorScheme.primary 
                    } else {
                        MaterialTheme.colorScheme.onSurface.copy(alpha = 0.3f)
                    }
                )
            }
        }

        if (editorSettings.syllableCountEnabled && line.text.isNotBlank()) {
            val count = remember(line.text) { countSyllables(line.text) }
            Text(
                text = count.toString(),
                style = MaterialTheme.typography.labelSmall,
                color = MaterialTheme.colorScheme.onSurfaceVariant,
                modifier = Modifier.padding(start = 8.dp)
            )
        }
    }
}


@Composable
fun WordFinderPopup(
    showPopup: Boolean,
    searchTerm: String,
    selectedTab: WordFinderTab,
    rhymeResults: List<String>,
    synonymResults: List<String>,
    isLoading: Boolean,
    error: String?,
    onDismiss: () -> Unit,
    onSearchTermChange: (String) -> Unit,
    onTabSelected: (WordFinderTab) -> Unit,
    onSearchClick: () -> Unit
) {
    if (!showPopup) return
    val keyboardController = LocalSoftwareKeyboardController.current
    val rhymeListState = rememberLazyListState()
    val synonymListState = rememberLazyListState()
    val currentStep by TutorialManager.currentStep.collectAsState()
    
    Dialog(onDismissRequest = onDismiss, properties = DialogProperties(usePlatformDefaultWidth = false)) {
        Card(modifier = Modifier.adaptiveSheetWidth().fillMaxHeight(0.7f), shape = MaterialTheme.shapes.large) {
            Box(modifier = Modifier.fillMaxSize()) {
                Column(modifier = Modifier.padding(16.dp)) {
                    OutlinedTextField(
                        value = searchTerm, onValueChange = onSearchTermChange, modifier = Modifier.fillMaxWidth(), label = { Text("Search Word") }, singleLine = true,
                        trailingIcon = { 
                            IconButton(
                                onClick = { 
                                    if (currentStep == TutorialStep.EDITOR_WORD_FINDER_SEARCH) {
                                        TutorialManager.nextStep()
                                    }
                                    keyboardController?.hide()
                                    onSearchClick() 
                                },
                                modifier = Modifier.tutorialTarget(TutorialStep.EDITOR_WORD_FINDER_SEARCH)
                            ) { Icon(Icons.Filled.Search, contentDescription = "Search") } 
                        },
                        keyboardOptions = KeyboardOptions(imeAction = ImeAction.Search), keyboardActions = KeyboardActions(onSearch = { keyboardController?.hide(); onSearchClick() })
                    )
                    Spacer(modifier = Modifier.height(16.dp))
                    val tabs = listOf("Rhymes", "Synonyms")
                    TabRow(selectedTabIndex = selectedTab.ordinal) {
                        tabs.forEachIndexed { index, title ->
                            Tab(selected = selectedTab.ordinal == index, onClick = { onTabSelected(if (index == 0) WordFinderTab.RHYMES else WordFinderTab.SYNONYMS) }, text = { Text(title) })
                        }
                    }
                    Spacer(modifier = Modifier.height(16.dp))
                    Box(modifier = Modifier.weight(1f), contentAlignment = Alignment.Center) {
                        when {
                            isLoading -> CircularProgressIndicator()
                            error != null -> Text(text = error, color = MaterialTheme.colorScheme.error, textAlign = TextAlign.Center, modifier = Modifier.padding(16.dp))
                            else -> {
                                when (selectedTab) {
                                    WordFinderTab.RHYMES -> {
                                        if (rhymeResults.isEmpty() && searchTerm.isNotBlank()) Text("No rhymes found.", textAlign = TextAlign.Center)
                                        else LazyColumn(modifier = Modifier.fillMaxSize(), state = rhymeListState) {
                                            items(rhymeResults) { word -> Text(text = word, modifier = Modifier.fillMaxWidth().padding(vertical = 8.dp)); HorizontalDivider() }
                                        }
                                    }
                                    WordFinderTab.SYNONYMS -> {
                                        if (synonymResults.isEmpty() && searchTerm.isNotBlank()) Text("No synonyms found.", textAlign = TextAlign.Center)
                                        else LazyColumn(modifier = Modifier.fillMaxSize(), state = synonymListState) {
                                            items(synonymResults) { word -> Text(text = word, modifier = Modifier.fillMaxWidth().padding(vertical = 8.dp)); HorizontalDivider() }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    Spacer(modifier = Modifier.height(8.dp)); Button(onClick = onDismiss, modifier = Modifier.align(Alignment.End)) { Text("Close") }
                }
                TutorialOverlay(isGlobal = false)
            }
        }
    }
}



